import { type ComponentIconProps, type IconName, SWReactIcons } from "@similarweb/icons";

import type { CategoryIconComponent } from "../types/category";

export const createLegacyCategoryIcon = (iconName: IconName): CategoryIconComponent => {
    return function LegacyCategoryIcon({
        color,
        size,
        className,
    }: Omit<ComponentIconProps, "size"> & {
        size: Exclude<ComponentIconProps["size"], number>;
    }) {
        return (
            <SWReactIcons
                iconName={iconName}
                size={size}
                iconColor={color}
                className={className}
            />
        );
    };
};
